import React from 'react';
import ReusableTabs from '../../../../pages/ReusableTabs';
import MaterialReturn from './MaterialReturnToStore';
import ContractorAnalysis from './ContractorAnalysis';
 
const ReturnToStoreTabs = () => {
  const tabs = [
    { label: 'Material Assign & Return', component: <MaterialReturn /> },
    { label: 'Contractor Analysis', component: <ContractorAnalysis /> },
  ];
 
  return (
    <ReusableTabs
      tabs={tabs}
      defaultTab={0}
      panelStyles={{ padding: '16px' }}
    />
  );
};
 
export default ReturnToStoreTabs;    